import data from "../data";
import { BiCodeAlt } from "react-icons/bi";
import { BiPaint } from "react-icons/bi";
import { FiTool } from "react-icons/fi";
import SkillCard from "./ui/SkillCard";

const Skills = () => {
  return (
    <div
      id="skills"
      className="mx-auto flex flex-col justify-center gap-8 px-4 sm:px-6 py-24 md:items-center max-w-5xl"
    >
      <div className="text-center space-y-2 mb-6">
        <h2 className="text-indigo-400 font-mono text-xs uppercase tracking-widest font-bold">Skills & Frameworks</h2>
        <h1 className="text-3xl font-extrabold text-white sm:text-4xl tracking-tight">
          Skills
        </h1>
      </div>
      <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4 justify-center w-full">
        <SkillCard title="Languages" tools={data.languages}>
          <BiCodeAlt className="text-secondary" size={35} />
        </SkillCard>
        <SkillCard title="Design" tools={data.design}>
          <BiPaint className="text-secondary" size={35} />
        </SkillCard>
        <SkillCard title="Tools" tools={data.tools}>
          <FiTool className="text-secondary" size={35} />
        </SkillCard>
        <SkillCard title="Libs & API" tools={data.lib}>
          <FiTool className="text-secondary" size={35}></FiTool>
        </SkillCard>
      </div>
    </div>
  );
};

export default Skills;
